export default function getRemoteURL(relativePath: string) {
	if (
		import.meta.env.VITE_REMOTE_BASE &&
		typeof import.meta.env.VITE_REMOTE_BASE === "string"
	) {
		return new URL(relativePath, import.meta.env.VITE_REMOTE_BASE).href;
	}
	if (
		import.meta.env.MODE === "development" ||
		import.meta.env.MODE === "staging"
	) {
		return new URL(relativePath, "http://localhost:8080").href;
	}
	return new URL(relativePath, window.location.origin).href;
}
